import store from './../../../store'

export function batchImgDownload(imgList) {
  for (let i = 0; i < imgList.length; i++) {
    imgDownload(imgList[i].path, imgList[i].id)
  }
}

export async function imgDownload(link, filename) {
  if (!link) {
    return
  }
  try {
    const fileUrl = process.env.VUE_APP_fileBasePath + link
    const response = await fetch(fileUrl)
    if (!response.ok) {
      throw new Error(`download failed: ${response.status}`)
    }
    const blob = await response.blob()
    const downloadUrl = window.URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = downloadUrl
    a.download = getDownloadFileName(link, filename)
    a.click()
    window.URL.revokeObjectURL(downloadUrl)
  } catch (error) {
    console.log('image download error:', error)
  }
}

function getDownloadFileName(link, filename) {
  const purePath = (link || '').split('?')[0]
  const originalName = purePath.split('/').pop()
  return originalName || filename || 'default.png'
}

export function hasPermission(permission) {
  const ls = store.getters.rolePermission
  const userType = store.state.user.userType
  // View Create Edit Full
  const kind = permission.split('_')[0]
  const _role = ls.find((o) => o.indexOf(kind) >= 0) || ''
  if (userType == '1') {
    return true
  } else {
    if (_role.length == 0) {
      // 没有相关权限
      return false
    } else {
      const _opt = _role.split('_')[1] || ''
      if (_opt.length == 0) {
        return false
      } else {
        if (_opt == 'Full') {
          return (
            permission == kind + '_View' ||
            permission == kind + '_Create' ||
            permission == kind + '_Edit' ||
            permission == kind + '_Full'
          )
        } else if (_opt == 'Edit') {
          return (
            permission == kind + '_View' ||
            permission == kind + '_Create' ||
            permission == kind + '_Edit'
          )
        } else if (_opt == 'Create') {
          return permission == kind + '_View' || permission == kind + '_Create'
        } else if (_opt == 'View') {
          return permission == kind + '_View'
        } else {
          return false
        }
      }
    }
  }
}
